import { createContext, useContext, useState, useEffect } from "react";
import { getPermissionsByRole } from "../services/utils";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
    const [permissions, setPermissions] = useState({});

    useEffect(() => {
        const storedUser = sessionStorage.getItem("user");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            if (parsedUser.role) {
                const rolePermissions = getPermissionsByRole(parsedUser.role);
                setPermissions(rolePermissions);
            }
        }
    }, []);

    const updatePermission = () => {
        const storedUser = sessionStorage.getItem("user");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            if (parsedUser.role) {
                const rolePermissions = getPermissionsByRole(parsedUser.role);
                setPermissions(rolePermissions);
            }
        }
    };

    return (
        <PermissionsContext.Provider value={{ permissions, updatePermission }}>
            {children}
        </PermissionsContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionsContext);


/* OLD CODE (Commented Out)
export const PermissionsProvider = ({ children }) => {
    const [permissions, setPermissions] = useState(() => {
        // Load from sessionStorage on first render
        const storedPermissions = sessionStorage.getItem("permissions");
        return storedPermissions ? JSON.parse(storedPermissions) : {};
    });

    const updatePermission = () => {
        const storedPermissions = sessionStorage.getItem("permissions");
        const updatedstoredPermissions = JSON.parse(storedPermissions);
        setPermissions(updatedstoredPermissions);
    };

    return (
        <PermissionsContext.Provider value={{ permissions, updatePermission }}>
            {children}
        </PermissionsContext.Provider>
    );
};
*/
